import { createStore } from 'vuex'

export default createStore({
  state: {
    adminurl:'https://primen.nsmlimited.com/',
    url:'https://adminprime.nsmlimited.com/',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
